export enum UrgencyLayouts {
  ONE = "Urgency 01",
  TWO = "Urgency 02",
  THREE = "Urgency 03",
  FOUR = "Urgency 04",
  FIVE = "Urgency 05",
  SIX = "Urgency 06"
}
